import m, {Vnode} from "mithril";
import naja from "naja";
import Swal from "sweetalert2";
import Translator from "../Translator";

export interface MediaPlayerActions {
    downloadUrl: string;
    deleteUrl: string;
}

export function readMediaPlayerActions(el: HTMLElement): MediaPlayerActions | null {
    const downloadUrl = el.getAttribute('data-download-url');
    const deleteUrl = el.getAttribute('data-delete-url');
    if (!downloadUrl || !deleteUrl) {
        return null;
    }
    el.removeAttribute('data-download-url');
    el.removeAttribute('data-delete-url');

    return {downloadUrl, deleteUrl};
}

export function renderMediaPlayerActions(actions: MediaPlayerActions, filename: string, translator: Translator): Vnode {
    return m('.dropdown.dropup.media-player-actions', [
        m('button.btn.btn-sm.btn-flat-primary.p-2.media-player-actions-toggle', {
            type: 'button',
            'data-bs-toggle': 'dropdown',
            'aria-expanded': 'false',
            'aria-label': translator.translate('actions'),
        }, m('i.bi.bi-three-dots-vertical')),
        m('ul.dropdown-menu.dropdown-menu-end', [
            m('li', m('span.dropdown-item-text.fs-9.text-muted', filename)),
            m('li', m('hr.dropdown-divider')),
            m('li', m('a.dropdown-item', {
                href: actions.downloadUrl,
                download: filename,
            }, [m('i.bi.bi-download.me-2'), translator.translate('download')])),
            m('li', m('a.ajax.dropdown-item.text-danger', {
                href: actions.deleteUrl,
                'data-confirm': translator.translate('confirm'),
            }, [m('i.bi.bi-trash-fill.me-2'), translator.translate('delete')])),
        ]),
    ]);
}

export function bindMediaPlayerActions(root: HTMLElement): void {
    naja.uiHandler.bindUI(root);
}

export function triggerFileDownload(url: string, filename: string): void {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
}

export async function showUnsupportedFormatDialog(url: string, filename: string, translator: Translator): Promise<void> {
    const result = await Swal.fire({
        text: translator.translate('media_unsupported_format'),
        showCancelButton: true,
        confirmButtonColor: "#8F3985",
        cancelButtonColor: "#6c757d",
        confirmButtonText: translator.translate('download'),
        cancelButtonText: translator.translate('cancel'),
    });
    if (result.isConfirmed) {
        triggerFileDownload(url, filename);
    }
}

export function isUnsupportedMediaError(media: HTMLMediaElement): boolean {
    const code = media.error?.code;
    return code === MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED || code === MediaError.MEDIA_ERR_DECODE;
}

export function renderUnsupportedNotice(
    url: string,
    filename: string,
    translator: Translator,
    extraClass = '',
): Vnode {
    return m('.media-player-unsupported' + extraClass, [
        m('span.media-player-unsupported-text', translator.translate('media_cannot_play')),
        m('a.media-player-unsupported-download', {
            href: url,
            download: filename,
        }, [m('i.bi.bi-download.me-1'), translator.translate('download')]),
    ]);
}
